import { GEnum } from '@/constants/enum.defination';
import { ApiService } from './api.service';
import { storageService } from '@/service/storage/storage.service';
import { SocialLoginDef } from '@/constants/socialLoginDef';

class SocialAuthService extends ApiService {
  constructor() {
    super();
  }

  private readonly GOOGLE_OAUTH2_BASE_URL = 'https://accounts.google.com/o/oauth2/v2/auth';
  private readonly MICROSOFT_OAUTH2_BASE_URL = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize';

  /**
   * ソーシャルログイン実行
   * @param type
   * @param state
   */
  public async doOAuthSignin(type: string) {
    // Google or Microsoft
    if (type != SocialLoginDef.Google && type != SocialLoginDef.Microsoft) {
      return
    }

    // create state
    const state = (crypto as any).randomUUID();
    storageService.oauthState = state;

    // state を key にして、ログインタイプ（google, microsoft, etc...）を保持しておく
    sessionStorage.setItem(`oauth:${state}`, type);

    // create code verifier
    const codeVerifier = this.generateCodeVerifier();
    storageService.oauthCodeVerifier = codeVerifier;

    // create code challenge (sha-256)
    const codeChallenge = await this.generateCodeChallenge(codeVerifier);

    switch (type) {
      case SocialLoginDef.Google:
        // google url
        const url = new URL(this.GOOGLE_OAUTH2_BASE_URL);
        // set params
        url.searchParams.set("client_id", process.env.VUE_APP_OAUTH2_CLIENTID);
        url.searchParams.set("redirect_uri", process.env.VUE_APP_OAUTH2_REDIRECT_URI);
        url.searchParams.set("response_type", "code");
        url.searchParams.set("scope", "openid email profile");
        url.searchParams.set("state", state);
        //url.searchParams.set("code_challenge", codeChallenge);
        //url.searchParams.set("code_challenge_method", "S256");
        //url.searchParams.set('type', GEnum.SocialLoginState.Google);
        return window.location.assign(url.href);
      case SocialLoginDef.Microsoft: {
        // microsoft url
        const url = new URL(this.MICROSOFT_OAUTH2_BASE_URL);
        // set params
        url.searchParams.set('client_id', process.env.VUE_APP_MS_OAUTH2_CLIENTID);
        url.searchParams.set('redirect_uri', process.env.VUE_APP_MS_OAUTH2_REDIRECT_URI);
        url.searchParams.set('response_type', 'code');
        url.searchParams.set('response_mode', 'query');
        url.searchParams.set('scope', 'user.read');
        url.searchParams.set('state', state);
        //url.searchParams.set('code_challenge', codeChallenge);
        //url.searchParams.set('code_challenge_method', 'S256');
        //url.searchParams.set('type', GEnum.SocialLoginState.Microsoft);
        return window.location.assign(url.href);
      }
    }

  }

  // code-verifier を生成
  public generateCodeVerifier(): string {
    const bytes = new Uint8Array(32);
    crypto.getRandomValues(bytes);

    return this.base64UrlEncode(bytes);
  }

  // code-verifier から code-challenge を生成
  public async generateCodeChallenge(verifier: string): Promise<string> {
    const encoder = new TextEncoder();

    const data = encoder.encode(verifier);

    const digest = await crypto.subtle.digest(
      "SHA-256",
      data
    );

    return this.base64UrlEncode(new Uint8Array(digest));
  }

  // encode Base64Url from Uint8Array
  public base64UrlEncode(bytes: Uint8Array): string {
    // Uint8Array → binary string
    let binary = "";

    for (const byte of bytes) {
      binary += String.fromCharCode(byte);
    }

    // base64 encode
    const base64 = btoa(binary);

    // base64 → base64url
    return base64
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  }
}

export const socialAuthService = new SocialAuthService();
